import type { OutboxOperation } from '$db/local/db';
import { objectToSnakeCase } from './case';

export interface HydratedOp {
  entity_type: string;
  entity_id: string;
  op: 'upsert' | 'delete';
  idempotency_key: string;
  schema_version: number;
  payload: Record<string, unknown>;
}

/**
 * Prepara una op de la outbox para el RPC apply_sync_batch.
 * - Convierte payload camelCase → snake_case.
 * - Garantiza field_meta: {} si la entidad no lo trae (Opción A).
 * - Para deletes, payload va vacío.
 */
export function hydrateForPush(op: OutboxOperation): HydratedOp {
  let payload: Record<string, unknown> = {};

  if (op.op === 'upsert' && op.payload && typeof op.payload === 'object') {
    payload = objectToSnakeCase(op.payload as Record<string, unknown>);
  }

  return {
    entity_type: op.entityType,
    entity_id: op.entityId,
    op: op.op,
    idempotency_key: op.idempotencyKey,
    schema_version: op.schemaVersion,
    payload
  };
}